import axios from 'axios';
import Vue from 'vue';
import { baseURL, xToken } from './env/env.json';
// eslint-disable-next-line import/no-cycle
import store from './store/storage';
// eslint-disable-next-line import/no-cycle
import router from './routes';

const baseApiURL = process.env.NODE_ENV === 'production'
  // eslint-disable-next-line no-restricted-globals
  ? `${location.protocol}//${location.hostname}${location.port ? `:${location.port}` : ''}/api`
  : baseURL;

const defaultRequest = (instance, state, loading = false) => {
  instance.interceptors.request.use(
    (config) => {
      if (state.token !== undefined && state.token) {
        config.headers.Authorization = `Bearer ${state.token}`;
      }
      state.loading = loading;
      return config;
    },
    error => Promise.reject(error),
  );
  return instance;
};

const defaultResponse = (instance, state) => {
  instance.interceptors.response.use(
    (response) => {
      state.loading = false;
      Vue.notify({ group: 'error', clean: true });
      return response;
    },
    (error) => {
      state.loading = false;
      if (error.response?.status === 423) {
        store.dispatch('UserLogout');
        if (router.currentRoute.path !== '/') {
          router.push('/', () => {
            if (error.response.data && error.response.data.error) {
              const text = ` ${error.response.data.error}`;
              Vue.notify({ group: 'info', type: 'error', text, duration: 7000 });
            }
          });
        }
      } else {
        Vue.notify({ group: 'error', clean: true });
      }


      return Promise.reject(error);
    },
  );

  return instance;
};

// eslint-disable-next-line import/prefer-default-export
export const ax = (state) => {
  const instance = axios.create({
    baseURL: baseApiURL,
    timeout: 60000,
    headers: { 'Content-Type': 'application/json', 'X-Token': xToken },
  });
  defaultRequest(instance, state);
  defaultResponse(instance, state);

  return instance;
};

export const axl = (state) => {
  const instance = axios.create({
    baseURL: baseApiURL,
    timeout: 60000,
    headers: { 'Content-Type': 'application/json', 'X-Token': xToken },
  });
  defaultRequest(instance, state, true);
  defaultResponse(instance, state);
  return instance;
};

export const axf = (state) => {
  const instance = axios.create({
    baseURL,
    timeout: 60000,
    headers: { 'Content-Type': 'application/json', 'X-Token': xToken },
    responseType: 'blob',
  });
  defaultRequest(instance, state, true);
  defaultResponse(instance, state);
  return instance;
};
